<demo-section [name]="name" [src]="src" [componentContent]="componentContent">
  <p>Dropdowns are toggleable, contextual overlays for displaying lists of links and more.
  They’re made interactive with the included dropdown directives.</p>
  <p>The easiest way to add the dropdown component to your app (will be added to the root module)</p>
  <pre class="prettyprint lang-bash prettyprinted"><span class="pln">ng add ngx</span><span class="pun">-</span><span class="pln">bootstrap </span> --component <span class="pln">dropdowns</span></pre>
  <docs-section [content]="componentContent"></docs-section>
</demo-section>
